import * as React from "react";
import { FieldValuePropertyPicker } from "typings/index";
import { BaseFieldEditor } from "../helper";
import { connect } from "react-redux";
import { RootState } from "~/state";

import styled from "styled-components";
import { DefaultButton } from "office-ui-fabric-react";
import PropertyPickerDialog from "./PropertyPickerDialog";
import { getFields, getTabs } from "~/state/action";
import { loadFields } from "~/state/field/action";
import { loadTabs } from "~/state/tab/action";
export interface Props extends BaseFieldEditor
{
    value: FieldValuePropertyPicker;
    placeholder?: string;
}


const  PropertyList = styled.div`
    background: white;
    padding: 10px;
    display: grid;
    clear: both;
    > button
    {
        clear: both;
        clear: both;
        width: 200px;
    }
    ul
    {
        list-style-type: none;
        margin: 0px;
        padding: 0px;
        li
        {
            margin: 10px 0px;
            button
            {
                margin-right:10px;
            }
            span
            {
                margin-top: 6px;
                display: inline-block;
            }
        }
    }
   
`;


const PropertyPicker: React.FunctionComponent<Props & StateProps> = props =>
{
    const [showPropertyPickerDialog, setShowPropertyPickerDialog] = React.useState<boolean>(false);
    React.useEffect(() =>
    {
        if (!props.properties || props.properties.length === 0)
        {
            props.loadFields();
        }

        if (!props.tabs || props.tabs.length === 0)
        {
            props.loadTabs();
        }
    }, []);
    
    const showDialog = () =>
    {
        setShowPropertyPickerDialog(true);
    };

    const onSave = (selectedProperties: string[]) =>
    {
        const fieldValue: FieldValuePropertyPicker = { ...props.value, value: selectedProperties.filter((v, i, a) => a.indexOf(v) === i) };
        props.onValueChange(fieldValue);
        setShowPropertyPickerDialog(false);
       
    };
    const hideDialog = () =>
    {
        setShowPropertyPickerDialog(false);
    };

    const removeProperty = React.useCallback((property: string) => () =>
    {
        if (props.value.value)
        {
            const fieldValue: FieldValuePropertyPicker = { ...props.value, value: props.value.value.filter(x => x !== property) };
            props.onValueChange(fieldValue);
        }

    }, [props.value]);

  
    const renderProperties = () =>
    {
        return props.value && props.value.value && props.value.value.map(property =>
        {
            const field = props.properties.find(x => x.field.name === property);
            if (field)
            {
                return (<li key={property}>
                        <DefaultButton onClick={removeProperty(property)} iconProps={{iconName: "Delete"}}></DefaultButton>
                        <span>{field.field.label._DEFAULT}</span>
                    </li>);

            }
            return null;
        });
    };
    let filters: string[] | undefined = undefined;
    if (props.field.tab)
    {
        const tab = props.tabs.find(x => x.tabName === props.field.tab);
        if (tab)
        {
            filters = tab.fields;
        }
        
    }
    console.log(props);
    return (
        <PropertyList>
            <ul>
            {renderProperties()}
            </ul>
            
            <DefaultButton iconProps={{iconName: "Add"}} onClick={showDialog}>Add properties</DefaultButton>

            {showPropertyPickerDialog ? <PropertyPickerDialog onSave={onSave} 
                properties={props.properties.filter(x => filters === undefined || filters.indexOf(x.field.name) > -1 )}
                selectedProperties={props.value && props.value.value ? props.value.value : []} hideDialog={hideDialog}></PropertyPickerDialog> 
            : null}
        </PropertyList>
    );
    
};


const mapStateToProps = (state: RootState, ownProps: Props) =>
{
   
    return {
        properties: getFields(state),
        tabs: getTabs(state)
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    loadFields: () => dispatch(loadFields()),
    loadTabs: () => dispatch(loadTabs())
});
type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

export default connect(mapStateToProps, mapDispatchToProps)(PropertyPicker);


// WEBPACK FOOTER //
// ./src/components/product/FieldEditor/propertyPicker/index.tsx